import { connect } from 'react-redux';
import {
  startPublishStepPoll,
  stopPublishStepPoll,
  resetOperationInfo,
  abortRequest,
} from './publish-steps-actions';
import ShortSteps from '../components/short-steps';

const mapStateToProps = state => ({
  operationInfo: state.currentStatus.operationInfo,
  error: state.currentStatus.error,
  isPolling: state.currentStatus.shouldPoll,
  isAborting: state.currentStatus.isAborting,
});

const mapDispatchToProps = {
  startPublishStepPoll,
  stopPublishStepPoll,
  resetOperationInfo,
  abortRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShortSteps);
